import React from "react";
import "./Section1.css";
import Section1Image from "../../../../../assets/images/itin-sec1img1.png";
import Section1Dots from "../../../../../assets/images/aboutus-dots.png";
const Section1 = () => {
  return (
    <div className="itinsrsrc1_section">
      <img src={Section1Dots} alt="" className="itinsrsrc1__section_dots" />
      <div className="itinsrsrc1__section_left">
        <img src={Section1Image} alt="" className="itinsrsrc1__section_img" />
      </div>
      <div className="itinsrsrc1__section_right">
        <div className="itinsrsrc1__secleft_description">
          <p>
            An Individual Taxpayer Identification Number (ITIN) is a tax
            processing number issued by the Internal Revenue Service for certain
            resident and non-resident aliens.Serene Tax helps you out filling
            the W7 form and process efficiently and effectively to ensure every
            individual to receive an ITIN.Using our services will guarantee your
            success in having the IRS issue you an ITIN.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Section1;
